import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import { auth } from '@/firebase';
import store from '@/store';
import { USER_ACTIONS } from '@/store/user/actions';
import { RootState } from '@/store/types';
import { UserState } from '@/store/user/types';

Vue.use(VueRouter)

import FactCheckRoutes from './modules/factchecks';
import AccountRoutes from './modules/accounts';
import ScraperRoutes from './modules/scraper';
import StatsRoutes from './modules/stats';
import AboutRoutes from './modules/about';
import SettingsRoutes from './modules/settings';
import RequestsRoutes from './modules/requests';
import GoogleClaimsRoutes from './modules/googleClaims';
import ConceptRoutes from './modules/concepts';
import ClaimCategoryRoutes from './modules/claimCategories';
import NewsletterRoutes from './modules/newsletter';
import SeoRoutes from './modules/seo';
import ApiRoutes from './modules/api';
import PartnerRoutes from './modules/partner';
import ContentRoutes from './modules/content';
import AiRoutes from './modules/ai';
import TwitterRoutes from './modules/twitter';
import RssRoutes from './modules/rss';
import IntegrationRoutes from './modules/integrations';
import WorkskopFormsRoutes from './modules/workshopForms';
import PartnerToolsRoutes from './modules/partnertools';
import BlogRoutes from './modules/blogs';
const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  ...FactCheckRoutes,
  ...AccountRoutes,
  ...ScraperRoutes,
  ...StatsRoutes,
  ...AboutRoutes,
  ...SettingsRoutes,
  ...RequestsRoutes,
  ...GoogleClaimsRoutes,
  ...ConceptRoutes,
  ...ClaimCategoryRoutes,
  ...SeoRoutes,
  ...ApiRoutes,
  ...PartnerRoutes,
  ...ContentRoutes,
  ...AiRoutes,
  ...TwitterRoutes,
  ...RssRoutes,
  ...IntegrationRoutes,
  ...WorkskopFormsRoutes,
  ...BlogRoutes,
  ...PartnerToolsRoutes,
  NewsletterRoutes,
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/signature',
    name: 'Signature',
    component: () => import('@/views/Signature.vue')
  },
  {
    path: '/error',
    component: () => import('@/views/Error.vue')
  },
  {
    path: '*',
    redirect: '/error?code:404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach(async (to, from, next) => {
  const currentUser = auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);

  if (requiresAuth && !currentUser) {
    // Back to the page asked for after logging in (e.g. RTBF following a link to its partner tool).
    next({ path: '/login', query: { redirect: to.fullPath } });
    return;
  }
  // Accounts and API keys: the API refuses them to non-admins, so the CMS does not show those screens either.
  if (requiresAdmin) {
    // The user module is registered on the store but not part of RootState's type.
    const profile = (): UserState['profile'] => (store.state as RootState & { user: UserState }).user.profile;
    if (!profile().id) await store.dispatch(USER_ACTIONS.AUTHENTICATE_USER);
    if (!profile().isAdmin) {
      next('/');
      return;
    }
  }
  next();
});

export default router
